/// <amd-module name="Wit/Common/WitSettingsViews/Components/StylesTable/StyleInterfaces" />
import { IObservableArray, IObservableValue } from "VSS/Core/Observable";
import { ICriteriaSelectedSettingData, ICriteriaSettingData } from "../CriteriaTable/CriteriaInterfaces";

/**
 * Represents values of the style setting
 */
export interface IStylesRuleData {
    /**
     * Currently selected rule name
     */
    ruleName: IObservableValue<string>;

    /**
     * Currently selected color in hex string
     */
    color: IObservableValue<string>;

    /**
     * Currently selected title color in hex string
     */
    titleColor: IObservableValue<string>;

    /**
     * Currently selected if enabled
     */
    isEnabled: IObservableValue<boolean>;

    /**
     * Currently selected if bold is selected
     */
    isTitleBold: IObservableValue<boolean>;

    /**
     * Currently selected if italics are on
     */
    isTitleItalicized: IObservableValue<boolean>;

    /**
     * Currently selected if underlined
     */
    isTitleUnderlined: IObservableValue<boolean>;

    /**
     * Rule id
     */
    id: string;

    /**
     * Currently selected criteria for all clauses of rule
     */
    selectedCriteriaData: ICriteriaSelectedSettingData[];

    /**
     * Criteria data for all clauses of rule
     */
    criteriaData: IObservableArray<ICriteriaSettingData>;
}

export interface IRuleData {
    ruleName: string;
    isEnabled: boolean;
    color: string;
    titleColor: string;
    isTitleBold: boolean;
    isTitleItalicized: boolean;
    isTitleUnderlined: boolean;
}
